<template>
    <div id="navigation">
        <div class="nav">
            <button :class="nav.toggleNav ? 'lines-button x close' : 'lines-button x'" type="button" role="button"
                    aria-label="Toggle Navigation" @click="nav.toggleNav = !nav.toggleNav">
                <span class="lines"></span>
            </button>
            <div class="nav-logo" :to="{ name: 'Home' }" @click="nav.toggleNav = false">
                <router-link tag="img" :to="{ name: 'Home' }" class="nav-logo" @click="nav.toggleNav = false"
                             :src="'https://elitecrafthomes.com/static_files/images/logo.png'"></router-link>
            </div>

            <div :class="nav.toggleNav ? 'ech-overlay-sidenav' : 'ech-overlay'">
                <div class="nav-content" v-show="nav.toggleNav || nav.windowWidth > 1024" @click="nav.toggleNav = false">
                    <router-link tag="div" :to="{ name: 'Communities' }" @click="nav.toggleNav = false"
                                 :class="$route.path.includes('communities') ? 'active' : ''">Communities</router-link>
                    <router-link tag="div" :to="{ name: 'Plans' }" @click="nav.toggleNav = false"
                                 :class="$route.path.includes('plans') ? 'active' : ''">Plans</router-link>
                    <router-link tag="div" :to="{ name: 'WhoWeAre' }" @click="nav.toggleNav = false"
                                 :class="$route.path.includes('about') ? 'active' : ''">About</router-link>
                    <router-link tag="div" :to="{ name: 'Contact' }" @click="nav.toggleNav = false"
                                 :class="$route.path.includes('contact') ? 'active' : ''">Contact</router-link>
                    <router-link tag="div" :to="{ name: 'Client' }" @click="nav.toggleNav = false"
                                 :class="$route.path.includes('client') ? 'active' : ''">Client Login</router-link>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    const nav = {
        nav: {
            toggleNav: false,
            windowWidth: 0
        }
    };

    export default {
        name: 'Navigation',
        data() {
            return nav;
        },
        methods: {
            getWindowWidth(event) {
                this.nav.windowWidth = document.documentElement.clientWidth;
            }
        },
        beforeMount() {
            this.getWindowWidth()
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth();
                // console.log(this.nav.windowWidth)
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        }
    }

</script>

<style lang="scss" scoped>

    @media screen and (max-width: 450px) {
        #navigation {
            div.nav {
                /* Container for all nav stuffs */
                height: 60px;
                background-color: white;
                position: relative;
                z-index: 998;
                /* Hide all nav items in a side view */
                /*div:not(:first-of-type), a:not(:first-of-type) {*/
                    /*display: none;*/
                /*}*/

                /* LOGO placement */
                div.nav-logo {
                    z-index: 999;
                    height: 50px;
                    position: absolute;
                    width: 100px;
                    top: 50%;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    img.nav-logo {
                        /*<!--position: absolute;-->*/
                        /*<!--top: 50%;-->*/
                        /*<!--left: 50%;-->*/
                        /*<!-- -ms-transform: translate(-50%, -50%);-->*/
                        /*<!--transform: translate(-50%, -50%);-->*/
                        width: 100px;
                        max-width: 100px;
                        height: 50px;
                        max-height: 50px;
                    }
                }

                /* Overlay for the side nav */
                .ech-overlay-sidenav {
                    height: 100%;
                    width: 100%;
                    position: fixed;
                    z-index: 997;
                    top: 0;
                    left: 0;
                    background-color: white;
                    overflow-x: hidden;
                    transition: 0.5s;
                    .nav-content {
                        position: relative;
                        top: 20%;
                        left: 33%;
                        width: 100%;
                        text-align: left;
                        div {
                            padding: 5px;
                            text-decoration: none;
                            font-size: 1.5em;
                            color: #818181;
                            display: block;
                            transition: 0.3s;
                        }
                    }

                }

                .ech-overlay {
                    height: 100%;
                    width: 0;
                    position: fixed;
                    z-index: 997;
                    top: 0;
                    left: 0;
                    background-color: white;
                    overflow-x: hidden;
                    transition: 0.5s;
                    .nav-content {
                        position: relative;
                        top: 20%;
                        left: 33%;
                        width: 100%;
                        text-align: left;
                        div {
                            padding: 5px;
                            text-decoration: none;
                            font-size: 1.5em;
                            color: #818181;
                            display: block;
                            /* TODO - think about adding in an opacity and visibility transition */
                            transition: 0.3s;
                        }
                    }

                }

                /* NAV hamburger */
                $button-size : 2em;
                $transition: .35s; // increase this to see the transformations in slow-motion
                $color: black;


                @mixin line {
                    display: inline-block;
                    width: $button-size;
                    height: $button-size/7;
                    background: $color;
                    border-radius: $button-size/14;
                    transition: $transition;
                }

                .lines-button.x {
                    /*transition: 0.5s;*/
                    //padding: $button-size/2 $button-size/4;
                    user-select: none;
                    cursor: pointer;
                    position: absolute;
                    left: 1.5625em;
                    top: 50%;
                    -ms-transform: translateY(-50%);
                    transform: translateY(-50%);
                    transition: $transition;
                    display: inline-block;
                    background-color: white;
                    border: none;
                    z-index: 999;
                    &:hover {
                        opacity: 1;
                    }

                    &:active {
                        transition: 0.5s;
                        background: #eee;
                    }
                    outline: none;
                }

                .lines {
                    outline: none;
                    //create middle line
                    @include line;
                    position: relative;

                    /*create the upper and lower lines as pseudo-elements of the middle line*/
                    &:before, &:after {

                        @include line;
                        position: absolute;
                        left: 0;
                        content: '';
                        transform-origin: $button-size/14 center;
                    }
                    &:before {
                        top: $button-size/4;
                    }
                    &:after {
                        top: -$button-size/4;
                    }
                }

                .lines-button.x.close {
                    background-color: white;
                    color: white;
                    /*right: 40%;*/
                    z-index: 999;
                    transition: 0.5s;
                }

                .lines-button.x.close .lines {
                    outline: none;
                    /* hide the middle line */
                    background: transparent;
                    color: black;

                    /* overlay the lines by setting both their top values to 0 */
                    &:before, &:after {
                        transform-origin: 50% 50%;
                        top: 0;
                        width: $button-size;
                    }

                    // rotate the lines to form the x shape
                    &:before {
                        transform: rotate3d(0, 0, 1, 45deg);
                    }
                    &:after {
                        transform: rotate3d(0, 0, 1, -45deg);
                    }
                }
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        #navigation {
            div.nav {
                /* Container for all nav stuffs */
                height: 100px;
                background-color: white;
                position: relative;
                z-index: 998;

                /* Hide all nav items in a side view */
                /*div:not(:first-of-type), a:not(:first-of-type) {*/
                /*display: none;*/
                /*}*/

                /* LOGO placement */
                div.nav-logo {
                    z-index: 999;
                    height: 80px;
                    position: absolute;
                    width: 150px;
                    top: 50%;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    img.nav-logo {
                        max-width: 150px;
                        width: 150px;
                        max-height: 80px;
                        height: 80px;
                        object-fit: fill;
                        cursor: pointer;
                    }
                }

                /* Overlay for the side nav */
                .ech-overlay-sidenav {
                    height: 100vh;
                    width: 100vw;
                    position: fixed;
                    z-index: 997;
                    top: 0;
                    left: 0;
                    background-color: white;
                    overflow-x: hidden;
                    transition: 0.5s;
                    .nav-content {
                        position: relative;
                        top: 20%;
                        left: 33%;
                        width: 100%;
                        text-align: left;
                        div {
                            padding: 5px;
                            text-decoration: none;
                            font-size: 2em;
                            color: #818181;
                            display: block;
                            transition: 0.3s;
                        }
                    }

                }

                .ech-overlay {
                    height: 100vh;
                    width: 0;
                    position: fixed;
                    z-index: 997;
                    top: 0;
                    left: 0;
                    background-color: white;
                    overflow-x: hidden;
                    transition: 0.5s;
                    .nav-content {
                        position: relative;
                        top: 20%;
                        left: 33%;
                        width: 100%;
                        text-align: left;
                        div {
                            padding: 5px;
                            text-decoration: none;
                            font-size: 2em;
                            color: #818181;
                            display: block;
                            /* TODO - think about adding in an opacity and visibility transition */
                            transition: 0.3s;
                        }
                    }

                }

                /* NAV hamburger */
                $button-size : 2.7em;
                $transition: .35s; // increase this to see the transformations in slow-motion
                $color: black;


                @mixin line {
                    display: inline-block;
                    width: $button-size;
                    height: $button-size/7;
                    background: $color;
                    border-radius: $button-size/14;
                    transition: $transition;
                }

                .lines-button.x {
                    /*transition: 0.5s;*/
                    //padding: $button-size/2 $button-size/4;
                    user-select: none;
                    cursor: pointer;
                    position: absolute;
                    left: 1.5625em;
                    top: 50%;
                    -ms-transform: translateY(-50%);
                    transform: translateY(-50%);
                    transition: $transition;
                    display: inline-block;
                    background-color: white;
                    border: none;
                    z-index: 999;
                    &:hover {
                        opacity: 1;
                    }

                    &:active {
                        transition: 0.5s;
                        background: #eee;
                    }
                    outline: none;
                }

                .lines {
                    outline: none;
                    //create middle line
                    @include line;
                    position: relative;

                    /*create the upper and lower lines as pseudo-elements of the middle line*/
                    &:before, &:after {

                        @include line;
                        position: absolute;
                        left: 0;
                        content: '';
                        transform-origin: $button-size/14 center;
                    }
                    &:before {
                        top: $button-size/4;
                    }
                    &:after {
                        top: -$button-size/4;
                    }
                }

                .lines-button.x.close {
                    background-color: white;
                    color: white;
                    /*right: 40%;*/
                    z-index: 999;
                    transition: 0.5s;
                }

                .lines-button.x.close .lines {
                    outline: none;
                    /* hide the middle line */
                    background: transparent;
                    color: black;

                    /* overlay the lines by setting both their top values to 0 */
                    &:before, &:after {
                        transform-origin: 50% 50%;
                        top: 0;
                        width: $button-size;
                    }

                    // rotate the lines to form the x shape
                    &:before {
                        transform: rotate3d(0, 0, 1, 45deg);
                    }
                    &:after {
                        transform: rotate3d(0, 0, 1, -45deg);
                    }
                }
            }
        }
    }

    @media screen and (min-width: 1025px) {
        #navigation {
            height: 100px;
            div.nav {
                height: 100px;
                position: relative;



                div.nav-logo {
                    height: 80px;
                    position: absolute;
                    width: 150px;
                    top: 50%;
                    left: 30%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    img.nav-logo {
                        max-width: 150px;
                        width: 150px;
                        max-height: 80px;
                        height: 80px;
                        object-fit: fill;
                        cursor: pointer;
                    }
                    img.nav-logo:hover, img.nav-logo:active, img.nav-logo:link {
                        text-decoration: none;
                        color: black;
                    }
                }

                .ech-overlay {
                    /*height: 100px;*/
                    position: absolute;
                    top: 0;
                    right: 7%;
                    padding: 0;
                    margin: 0;
                    .nav-content {
                        height: 100px;
                        .active {
                            color: black;
                            font-weight: bold;
                            &:after {
                                content: " ";
                                display: block;
                                width: 50%;
                                margin: -20px auto 0 auto;
                                padding-top: -10px;
                                border-bottom: 3px solid black;
                                border-radius: 1.5em;
                            }
                        }


                        div {
                            display: inline-block;
                            line-height: 4.32;
                            padding: 10px 10px 0 10px;
                            text-decoration: none;
                            font-size: 1.5em;
                            color: #818181;
                            border-bottom: none;
                            -webkit-transition: border-bottom 500ms;
                            -moz-transition: border-bottom 500ms;
                            -o-transition: border-bottom 500ms;
                            transition: border-bottom 500ms;
                            cursor: pointer;
                            /* TODO - think about adding in an opacity and visibility transition */
                            &:hover {

                                &:after {
                                    content: " ";
                                    display: block;
                                    width: 50%;
                                    margin: -20px auto 0 auto;
                                    padding-top: -10px;
                                    border-bottom: 3px solid black;
                                    border-radius: 1.5em;
                                }
                            }

                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue